import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7764f4f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-header" }
const _hoisted_2 = { class: "menu-content" }
const _hoisted_3 = { class: "landing-menu md-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "buttons md-hidden"
}
const _hoisted_5 = { class: "d-none md-block" }

import { IonImg, IonButtons, IonMenuButton, IonButton } from "@ionic/vue";
import { useRouter } from "vue-router";
import { EntitiesEnum } from "@/const/entities";
import { ref } from "vue";
import useUser from "@/hooks/useUser";
import { clearAuthItems } from "@/router/middleware/auth";
import useRoles from "@/hooks/useRole";
import { RoleEnum } from "@/generated/graphql";


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingHeader',
  props: {
    hideAuthBtn: { type: Boolean },
    fixed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const { isLoggedIn } = useUser();
const { role } = useRoles()

const router = useRouter();

const goToLogin = () => {
	router.push({ name: EntitiesEnum.Login });
};
const goToRegister = () => {
	router.push({ name: EntitiesEnum.Register });
};

const onLogout = () => {
  clearAuthItems();
  router.push({ name: EntitiesEnum.Login });
};
const goToDashboard = () => {
	if(role === RoleEnum.User){
		return router.push({
			name: EntitiesEnum.DashboardUserOverview
		})
	}
	router.push({ name: EntitiesEnum.DashboardOverview });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "landing-header__container hide-if-native",
    style: _normalizeStyle(_ctx.fixed?{position: 'fixed', zIndex: 999}:'')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonImg), {
              src: "assets/icon/logo-complete.png",
              class: "logo",
              alt: "logo"
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/about-us",
            class: "landing-menu__item"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" About us ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact-us",
            class: "landing-menu__item"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Contact us ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/terms-of-use",
            class: "landing-menu__item"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Terms of use ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/how-it-works",
            class: "landing-menu__item"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" How it works ")
            ]),
            _: 1
          })
        ])
      ]),
      (!_ctx.hideAuthBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!_unref(isLoggedIn))
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 0,
                  class: "login-btn",
                  type: "button",
                  fill: "clear",
                  onClick: goToLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Log in ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(isLoggedIn))
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 1,
                  class: "get-started-btn",
                  type: "button",
                  onClick: goToRegister
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Get started ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isLoggedIn))
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 2,
                  class: "login-btn",
                  type: "button",
                  fill: "clear",
                  onClick: onLogout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Log out ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isLoggedIn))
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 3,
                  class: "get-started-btn",
                  type: "button",
                  onClick: goToDashboard
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Dashboard ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(IonMenuButton), null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, { src: "assets/icon/menu-icon.svg" })
          ]),
          _: 1
        })
      ])
    ])
  ], 4))
}
}

})